import { AlertColor } from '@mui/material';
import { createContext } from 'react';

type SnackbarContextData = {
  showSnackbarMessage: (
    message: string,
    severity: AlertColor,
    duration?: number
  ) => void;
};

const SnackbarContext = createContext<SnackbarContextData>({
  showSnackbarMessage: () => {
    // noop
  }
});
export { SnackbarContext };

export default SnackbarContext;
